import { useEffect } from 'react';
import classNames from 'classnames/bind';
import withComponentName from '../../../decorators/withComponentName';

import useSizes from '../../../hooks/sizes';

import Styles from '../styles.module.scss';

import { TEAMMATES, TEAMMATES_MOBILE } from '../../../data/about/teammates';

const cx = classNames.bind(Styles);

const AboutUsFalconsSection = () => {
  const { width } = useSizes();

  useEffect(() => {
    const preloadTags = [];

    // eslint-disable-next-line guard-for-in
    for (const teamName in TEAMMATES_MOBILE) {
      const team = TEAMMATES_MOBILE[teamName];

      // eslint-disable-next-line guard-for-in
      for (const rowName in team) {
        const row = team[rowName];

        row?.forEach((teammate) => {
          if (!teammate.happy) {
            return;
          }

          const preloadTag = document.createElement('link');
          preloadTag.rel = 'preload';
          preloadTag.as = 'image';
          preloadTag.href = teammate.happy;
          preloadTags.push(preloadTag);
        });
      }
    }

    const fragment = document.createDocumentFragment();
    preloadTags.forEach((tag) => {
      fragment.appendChild(tag);
    });
    document.head.appendChild(fragment);

    return () => {
      preloadTags.forEach((tag) => {
        document.head.removeChild(tag);
      });
    };
  }, []);

  const team = width < 768 ? TEAMMATES_MOBILE : TEAMMATES;
  return (
    <div className={Styles['about-falcons-section']}>
      <div className={Styles.section}>
        <h2>The Falcons</h2>
        <div className={Styles['flex-wrapper']}>
          <div className={cx('flex-column', 'admin')}>
            <h4 className={Styles['subsection-heading']}>Management and Administration</h4>
            <div className={Styles['subsection-row']}>
              {team.managementTeam.firstRow.map((teammate, i) => (
                <div className={Styles['team-block-item']} key={i}>
                  <img loading="lazy" src={teammate.general} alt="" className={Styles['aboutus-team-firstimg']} />
                  <img loading="lazy" src={teammate.happy} alt="" className={Styles['aboutus-team-secondimg']} />
                </div>
              ))}
            </div>
            <div className={Styles['subsection-row']}>
              {team.managementTeam.secondRow.map((teammate, i) => (
                <div className={Styles['team-block-item']} key={i}>
                  <img loading="lazy" src={teammate.general} alt="" className={Styles['aboutus-team-firstimg']} />
                  <img loading="lazy" src={teammate.happy} alt="" className={Styles['aboutus-team-secondimg']} />
                </div>
              ))}
            </div>
          </div>
          <div className={cx('flex-column', 'developers')}>
            <h4 className={Styles['subsection-heading']}>Developers and Data Scientists</h4>
            <div className={Styles['subsection-row']}>
              {team.developersTeam.firstRow.map((teammate, i) => (
                <div className={Styles['team-block-item']} key={i}>
                  <img loading="lazy" src={teammate.general} alt="" className={Styles['aboutus-team-firstimg']} />
                  <img loading="lazy" src={teammate.happy} alt="" className={Styles['aboutus-team-secondimg']} />
                </div>
              ))}
            </div>
            <div className={Styles['subsection-row']}>
              {team.developersTeam.secondRow.map((teammate, i) => (
                <div className={Styles['team-block-item']} key={i}>
                  <img loading="lazy" src={teammate.general} alt="" className={Styles['aboutus-team-firstimg']} />
                  <img loading="lazy" src={teammate.happy} alt="" className={Styles['aboutus-team-secondimg']} />
                </div>
              ))}
            </div>
            <div className={Styles['subsection-row']}>
              {team.developersTeam?.thirdRow?.map((teammate, i) => (
                <div className={Styles['team-block-item']} key={i}>
                  <img loading="lazy" src={teammate.general} alt="" className={Styles['aboutus-team-firstimg']} />
                  <img loading="lazy" src={teammate.happy} alt="" className={Styles['aboutus-team-secondimg']} />
                </div>
              ))}
            </div>
            <div className={Styles['subsection-row']}>
              {team.developersTeam?.fourthRow?.map((teammate, i) => (
                <div className={Styles['team-block-item']} key={i}>
                  <img loading="lazy" src={teammate.general} alt="" className={Styles['aboutus-team-firstimg']} />
                  <img loading="lazy" src={teammate.happy} alt="" className={Styles['aboutus-team-secondimg']} />
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className={Styles['flex-wrapper']}>
          <div className={cx('flex-column', 'qa')}>
            <h4 className={Styles['subsection-heading']}>Quality Assurance</h4>
            <div className={Styles['subsection-row']}>
              {team.qasTeam.firstRow.map((teammate, i) => (
                <div className={Styles['team-block-item']} key={i}>
                  <img loading="lazy" src={teammate.general} alt="" className={Styles['aboutus-team-firstimg']} />
                  <img loading="lazy" src={teammate.happy} alt="" className={Styles['aboutus-team-secondimg']} />
                </div>
              ))}
            </div>
            <div className={Styles['subsection-row']}>
              {team.qasTeam?.secondRow?.map((teammate, i) => (
                <div className={Styles['team-block-item']} key={i}>
                  <img loading="lazy" src={teammate.general} alt="" className={Styles['aboutus-team-firstimg']} />
                  <img loading="lazy" src={teammate.happy} alt="" className={Styles['aboutus-team-secondimg']} />
                </div>
              ))}
            </div>
            <div className={Styles['subsection-row']}>
              {team.qasTeam?.thirdRow?.map((teammate, i) => (
                <div className={Styles['team-block-item']} key={i}>
                  <img loading="lazy" src={teammate.general} alt="" className={Styles['aboutus-team-firstimg']} />
                  <img loading="lazy" src={teammate.happy} alt="" className={Styles['aboutus-team-secondimg']} />
                </div>
              ))}
            </div>
          </div>
          <div className={cx('flex-column', 'ui')}>
            <h4 className={Styles['subsection-heading']}>UI/UX Designers</h4>
            <div className={Styles['subsection-row']}>
              {team.designersTeam.firstRow.map((teammate, i) => (
                <div className={Styles['team-block-item']} key={i}>
                  <img loading="lazy" src={teammate.general} alt="" className={Styles['aboutus-team-firstimg']} />
                  <img loading="lazy" src={teammate.happy} alt="" className={Styles['aboutus-team-secondimg']} />
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className={Styles['flex-wrapper']}>
          <div className={cx('flex-column', 'fa')}>
            <h4 className={Styles['subsection-heading']}>Financial Analysts</h4>
            <div className={Styles['subsection-row']}>
              {team.financialTeam.firstRow.map((teammate, i) => (
                <div className={Styles['team-block-item']} key={i}>
                  <img loading="lazy" src={teammate.general} alt="" className={Styles['aboutus-team-firstimg']} />
                  <img loading="lazy" src={teammate.happy} alt="" className={Styles['aboutus-team-secondimg']} />
                </div>
              ))}
            </div>
            <div className={Styles['subsection-row']}>
              {team.financialTeam.secondRow.map((teammate, i) => (
                <div className={Styles['team-block-item']} key={i}>
                  <img loading="lazy" src={teammate.general} alt="" className={Styles['aboutus-team-firstimg']} />
                  <img loading="lazy" src={teammate.happy} alt="" className={Styles['aboutus-team-secondimg']} />
                </div>
              ))}
            </div>
            <div className={Styles['subsection-row']}>
              {team.financialTeam?.thirdRow?.map((teammate, i) => (
                <div className={Styles['team-block-item']} key={i}>
                  <img loading="lazy" src={teammate.general} alt="" className={Styles['aboutus-team-firstimg']} />
                  <img loading="lazy" src={teammate.happy} alt="" className={Styles['aboutus-team-secondimg']} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withComponentName(AboutUsFalconsSection);
